import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface State {
  hiddenUris: string[]
  hidePost: (uri: string) => void
  unhidePost: (uri: string) => void
  clearAll: () => void
}

export const useHiddenPosts = create<State>()(
  persist(
    (set, get) => ({
      hiddenUris: [],
      hidePost: (uri) => {
        if (!get().hiddenUris.includes(uri))
          set((s) => ({ hiddenUris: [...s.hiddenUris, uri] }))
      },
      unhidePost: (uri) =>
        set((s) => ({ hiddenUris: s.hiddenUris.filter((u) => u !== uri) })),
      clearAll: () => set({ hiddenUris: [] }),
    }),
    { name: 'bskyhq:hidden-posts', version: 1 },
  ),
)
